<h1 class="header" [ngClass]="{'inactive-job': !job.is_active}">Summary</h1>

<ul class="description-text" [ngClass]="{'inactive-job': !job.is_active}">
  <!-- <li *ngFor="let item of job?.summary || []">{{ item }}</li> -->
   @for(item of job.summary; track $index) {
     <li>{{ item }}</li>
   }
  
  <!-- Optional fallback if there is no summary -->
   @if(!(job.summary.length)) {
     <li>No description available.</li>
   }
 
</ul>